<script>
import img from '../assets/free-issue-tasks-table.png'
import bottomImg from '../assets/bottom-img.png'
import mobileBottomImg from '../assets/mobile-bottom-img.png'

export default {
	pageView: true,
	data() {
		return {
			img,
			bottomImg,
			mobileBottomImg,
			loading: false,
			error: false,
			validation: {},
			form: {
				nameTo: null,
				nameFrom: null,
				email: null,
				inscription: null,
			},
		}
	},
	computed: {
		isMobile() {
			return this.$vuetify.breakpoint.xs
		},
	},
	methods: {
		submitForm() {
			if (this.error) return
			if (this.$route.query.origin) {
				this.form.origin = this.$route.query.origin
			}
			this.$shopApi.post({
				url: '/free-issue-form/tasks',
				data: this.form,
				loading: (v) => (this.loading = v),
				onValidation: ({ validation }) => (this.validation = validation),
				done: ({ success }) => {
					if (success) {
						this.$router.push({
							name: 'others.free-issue-thanks',
							params: { key: 'tareas', email: this.form.email },
							query: this.$route.query,
						})
					} else {
						this.error = true
						setTimeout(() => (this.error = false), 4000)
					}
				},
			})
		},
	},
	mounted() {
		this.$prerenderReady()
	},
}
</script>
<template>
	<div class="page-bg-container">
		<div class="d-flex flex-column align-center justify-center pb-10">
			<Container width="800px">
				<div class="darkblue--text font-weight-bold text-center mb-3 font-6 font-md-10">
					Incentivar la autonomía en tus peques, ¡es posible!
				</div>
				<div class="text-center mb-3 font-2">
					Promueve la independencia de los más pequeños con esta archi mega útil tabla de actividades
					diarias con su nombre. Descárgala GRATIS.
				</div>
			</Container>
			<div class="darkblue w100 py-10 my-10">
				<Container>
					<v-row>
						<v-col cols="12" md="6">
							<Media :src="img" width="100%" contain></Media>
						</v-col>
						<v-col cols="12" md="6">
							<div class="white--text font-6 text-center mb-8">
								¡Psst! Completa estos datos y recibe la tabla con el nombre de tu peque.
							</div>
							<Validator :validation="validation">
								<div>
									<label class="white--text">Nombre de tu peque</label>
									<TextField
										v-model="form.nameTo"
										validator-key="nameTo"
										label="Ingresa su nombre aquí"
										class="customization-tf mb-3"
										solo
										height="50"
										counter="13"
										maxlength="13"
									/>
									<label class="white--text">Tu correo</label>
									<TextField
										v-model="form.email"
										validator-key="email"
										placeholder="Ingresa tu correo electrónico aquí"
										class="customization-tf mb-3"
										solo
										height="50"
									/>
								</div>
							</Validator>
							<Button
								:color="error ? 'white' : 'orange'"
								:text="error"
								class="white--text px-15 mt-8"
								block
								x-large
								@click="submitForm"
								:loading="loading"
							>
								<span v-if="error">Oops! Ocurrio un error. Intenta nuevamente.</span>
								<span v-else>¡Quiero!</span>
							</Button>
						</v-col>
					</v-row>
				</Container>
			</div>
			<Media
				:src="isMobile ? mobileBottomImg : bottomImg"
				width="100%"
				max-width="950px"
				max-height="350px"
				contain
			/>
		</div>
	</div>
</template>

<style scoped>
.input {
	border-right: 1px solid lightgray;
}
.input >>> input {
	color: var(--v-darkblue-base);
}
.v-text-field ::v-deep .v-counter {
	color: white;
}
</style>
